export default __webpack_public_path__ + "static/media/PatternsMobile.6b6bd49d.svg";